export const POST_REQUEST = "POST_REQUEST";
export const SPACE_REQUEST = "SPACE_REQUEST";
export const BANNER_REQUEST = "SPACE_REQUEST";

export const POST_REQUEST_FAILURE = "POST_REQUEST_FAILURE";
export const SPACE_REQUEST_FAILURE = "SPACE_REQUEST_FAILURE";
export const BANNER_REQUEST_FAILURE = "SPACE_REQUEST_FAILURE";

export const POST_REQUEST_SUCCESS = "POST_REQUEST_SUCCESS";
export const SPACE_REQUEST_SUCCESS = "SPACE_REQUEST_SUCCESS";
export const BANNER_REQUEST_SUCCESS = "SPACE_REQUEST_SUCCESS";

export const ATTACHMENT_TYPES = {
  IMAGE: 1,
  VIDEO: 2,
  AUDIO: 3,
  YOUTUBE: 4,
  GIF_IMAGE: 5,
  GIF_LINK: 6
};
